module.exports = __webpack_public_path__ + "img/y_2017.7af2f9e0.png";